import { render, staticRenderFns } from "./FeedDetail.vue?vue&type=template&id=d9a57878&scoped=true&"
import script from "./FeedDetail.vue?vue&type=script&lang=js&"
export * from "./FeedDetail.vue?vue&type=script&lang=js&"
import style0 from "./FeedDetail.vue?vue&type=style&index=0&id=d9a57878&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9a57878",
  null
  
)

export default component.exports